/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'confluence.project-pages.improvement.provisioning-background.text': '此操作用时不超过一分钟',
  'confluence.project-pages.improvement.provisioning-background.title': '正在设置项目页面',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': '关闭',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': '完成',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': '下一页',
  'project-pages.activating.description':
    '已连接的 Confluence 空间尚未准备就绪。如果刷新无法修复问题，则请{contactSupport}。',
  'project-pages.activating.heading': 'Confluence 仍在加载',
  'project-pages.better-together-templates.meeting-notes.action-items-heading': '操作项有哪些？',
  'project-pages.better-together-templates.meeting-notes.agenda-item-label': '议程项目',
  'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': '输入“/Jira”可创建事务',
  'project-pages.better-together-templates.meeting-notes.date-label': '日期',
  'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': '讨论主题',
  'project-pages.better-together-templates.meeting-notes.list-people': '使用以下方法列出人员：',
  'project-pages.better-together-templates.meeting-notes.mention': '提及',
  'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': '人员以将其分配给操作项',
  'project-pages.better-together-templates.meeting-notes.notes-label': '备注',
  'project-pages.better-together-templates.meeting-notes.page-title': '会议记录',
  'project-pages.better-together-templates.meeting-notes.participants-label': '参与者',
  'project-pages.better-together-templates.meeting-notes.project-label': '项目',
  'project-pages.better-together-templates.product-requirements.create-a-jira-issue': '输入“/Jira”可创建事务',
  'project-pages.better-together-templates.product-requirements.design-heading': '设计',
  'project-pages.better-together-templates.product-requirements.embedd-different-data-views':
    '嵌入 Jira 项目中的不同数据和视图。',
  'project-pages.better-together-templates.product-requirements.heading': '概述',
  'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed':
    '您如何确定是否已解决问题？',
  'project-pages.better-together-templates.product-requirements.impact-heading': '影响',
  'project-pages.better-together-templates.product-requirements.inScopeStatus': '范围内',
  'project-pages.better-together-templates.product-requirements.insert-design-link': '插入指向您设计（Figma 等）的链接',
  'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira 事务',
  'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira 路线图',
  'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': '了解如何使用智能链接',
  'project-pages.better-together-templates.product-requirements.list-dashboards': '列出仪表板（Amplitude、Mode 等）',
  'project-pages.better-together-templates.product-requirements.list-design-considerations': '列出设计或构建注意事项',
  'project-pages.better-together-templates.product-requirements.list-people': '使用以下方法列出人员：',
  'project-pages.better-together-templates.product-requirements.mention': '提及',
  'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them':
    '人员以将其分配给操作项',
  'project-pages.better-together-templates.product-requirements.niceToHaveStatus': '最好执行',
  'project-pages.better-together-templates.product-requirements.outOfScopeStatus': '超出范围',
  'project-pages.better-together-templates.product-requirements.page-title': '产品需求',
  'project-pages.better-together-templates.product-requirements.pro-tip': '专家提示：',
  'project-pages.better-together-templates.product-requirements.problem-label': '问题',
  'project-pages.better-together-templates.product-requirements.requirement-heading': '要求',
  'project-pages.better-together-templates.product-requirements.scope-heading': '范围',
  'project-pages.better-together-templates.product-requirements.success-metric': '成功指标',
  'project-pages.better-together-templates.product-requirements.target-release-date': '目标发布日期',
  'project-pages.better-together-templates.product-requirements.team-label': '团队',
  'project-pages.better-together-templates.product-requirements.to-do-list-heading': '待办列表',
  'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': '您要尝试解决什么问题？',
  'project-pages.better-together-templates.retro-notes.retro-heading': '回顾',
  'project-pages.better-together-templates.retro.action-items-heading': '操作项有哪些？',
  'project-pages.better-together-templates.retro.create-a-jira-issue': '输入“/Jira”可创建事务',
  'project-pages.better-together-templates.retro.date-label': '日期',
  'project-pages.better-together-templates.retro.embed-it-here': '完成后，您可以将其嵌入此处。',
  'project-pages.better-together-templates.retro.list-people': '使用以下方法列出人员：',
  'project-pages.better-together-templates.retro.mention': '提及',
  'project-pages.better-together-templates.retro.mention-people-to-assign-them': '人员以将其分配给操作项',
  'project-pages.better-together-templates.retro.page-title': '回顾',
  'project-pages.better-together-templates.retro.participants-label': '参与者',
  'project-pages.better-together-templates.retro.pro-tip': '专家提示：',
  'project-pages.better-together-templates.retro.project-label': '项目',
  'project-pages.better-together-templates.retro.this-is-a-whiteboard': '这是 Confluence 白板。',
  'project-pages.better-together-templates.retro.use-a-whiteboard': '将 Confluence 白板用于回顾。',
  'project-pages.better-together-templates.retro.use-it-to-vote': '您可以将其用于投票并与您的团队合作。',
  'project-pages.button.connect-different-space-or-page.label': '更新空间或页面图标',
  'project-pages.button.connect-different-space-or-page.tooltip': '连接其他空间或项目',
  'project-pages.button.connect-space-or-page.tooltip': '连接到 Confluence',
  'project-pages.button.go-to-connected-live-doc.tooltip': '在 Confluence 中打开实时文档',
  'project-pages.button.go-to-connected-page.tooltip': '在 Confluence 中打开页面',
  'project-pages.button.go-to-connected-space.tooltip': '在 Confluence 中打开空间',
  'project-pages.connect-space-dialog.connection-error': '连接失败。',
  'project-pages.connect-space-dialog.connection-retry': '重试',
  'project-pages.connect-space-dialog.content.space-or-page-selector.description': '选择要连接至您项目的空间或项目。',
  'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': '在 Confluence 中搜索',
  'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description':
    '此项目需连接至一个空间，您才能创建项目。请选择要连接至此项目的空间。',
  'project-pages.connect-space-dialog.error-icon': '错误：',
  'project-pages.connect-space-dialog.footer.cancel': '取消',
  'project-pages.connect-space-dialog.footer.connect-space': '连接',
  'project-pages.connect-space-or-page-dialog.header.title': '将项目连接到 Confluence',
  'project-pages.connect-space.description':
    '空间类似文件夹 - 您可以使用它们就与项目相关的所有内容进行创建、组织和协作。',
  'project-pages.connect-space.not-connected.description':
    '若要使用项目页面，请联系您的管理员或团队负责人，将 Confluence 连接到此项目。',
  'project-pages.connect-space.not-connected.heading': '未连接到 Confluence',
  'project-pages.connect-success-flag.description.content': '已成功连接 {connectedSpaceOrPageName} 内容。',
  'project-pages.connection-error.space-or-page-not-found.button': '连接到其他空间或页面',
  'project-pages.create-space-dialog.connection-error': '连接失败。',
  'project-pages.create-space-dialog.connection-retry': '重试',
  'project-pages.create-space-dialog.content.empty-name': '请为空间命名。',
  'project-pages.create-space-dialog.content.invalid-name': '空间名称至少需包含一个字母或数字。',
  'project-pages.create-space-dialog.content.placeholder': '输入空间名称',
  'project-pages.create-space-dialog.creation-error': '空间创建失败。',
  'project-pages.create-space-dialog.error-icon': '错误：',
  'project-pages.create-space-dialog.footer.cancel': '取消',
  'project-pages.create-space-dialog.footer.create-space': '创建',
  'project-pages.create-space-dialog.header.title': '创建新的 Confluence 空间',
  'project-pages.cross-join.access-revoked.templates.subtitle':
    '您无法使用项目页面，因为管理员已拒绝您访问 Confluence。请联系站点管理员申请访问权限。',
  'project-pages.cross-join.access-revoked.templates.title': '您无权使用项目页面',
  'project-pages.cross-join.avatar.view-profile': '查看个人资料',
  'project-pages.cross-join.denied-request.templates.subtitle':
    '您无法使用项目页面，因为站点管理员拒绝了您加入 Confluence 的请求。',
  'project-pages.cross-join.denied-request.templates.title': '您的管理员已拒绝您访问',
  'project-pages.cross-join.direct-access.button-subtitle.experimental':
    '您将获得 Confluence 的访问权限。站点管理员已批准您加入。',
  'project-pages.cross-join.errors.unknown-error.description': '如果刷新无法修复问题，则请{contactSupport}。',
  'project-pages.cross-join.errors.unknown-error.title': '当前无法显示项目页面',
  'project-pages.cross-join.inline-join-product.button': '您将获得 Confluence 的访问权限。站点管理员已批准您加入。',
  'project-pages.cross-join.inline-join-product.connected.description': '在一个集中位置查看、编辑和创建文档',
  'project-pages.cross-join.inline-join-product.connected.title': '在项目页面上与您的团队开展协作',
  'project-pages.cross-join.pending-request.templates.subtitle':
    '站点管理员已收到您加入 Confluence 的请求。如果您被批准加入，项目页面将开始运行，我们也会向您发送确认电子邮件。',
  'project-pages.cross-join.pending-request.templates.subtitle.experiment':
    '请求获得批准后，您将收到一封包含“项目页面”访问权限的电子邮件。',
  'project-pages.cross-join.pending-request.templates.title': '您已请求访问 Confluence',
  'project-pages.cross-join.pending-request.templates.title.experiment': '已向管理员发送访问请求',
  'project-pages.cross-join.request-access-without-better-together.connected.description':
    '与您的团队一起查看、编辑和创建项目文档',
  'project-pages.cross-join.request-access.button': '请求访问',
  'project-pages.cross-join.request-access.button-subtitle.experimental':
    '选择“加入您的团队”，即表示您请求加入 Confluence 并同意与管理员分享您的 Atlassian 个人资料。',
  'project-pages.cross-join.request-access.button.experimental': '加入您的团队',
  'project-pages.cross-join.request-access.connected.description.experimental':
    '您的团队无需离开 Jira，即可使用“项目页面”来评论、编辑和协作处理项目文档。加入 Confluence 以访问您团队的“项目页面”。',
  'project-pages.cross-join.request-access.title': '项目页面需要访问 Confluence',
  'project-pages.cross-join.request-access.title.experiment': '为您的团队创建单一事实来源',
  'project-pages.default-contextual-heading': '项目页面由 Confluence 提供支持',
  'project-pages.default-contextual-message': '使用 Confluence 页面在一个位置创建、共享和合作所有项目文档。',
  'project-pages.default-reactivate-CTA': '重新激活 Confluence',
  'project-pages.default-trial-CTA': '免费试用 Confluence 30 天',
  'project-pages.draft-saved-flag.action': '打开草稿',
  'project-pages.draft-saved-flag.description': '在您发布草稿之前，您的草稿仅对您自己可见。',
  'project-pages.draft-saved-flag.title': '草稿已保存',
  'project-pages.embedded-pages.create-page-error.close-button': '关闭',
  'project-pages.embedded-pages.create-page-error.description': '出现问题，无法为您创建页面。',
  'project-pages.embedded-pages.create-page-error.title': '无法创建页面',
  'project-pages.embedded-pages.create-page-error.try-again-button': '请重试',
  'project-pages.embedded-pages.modal.close.button.hint': '关闭',
  'project-pages.embedded-pages.modal.title.button': '在 Confluence 中打开',
  'project-pages.embedded-pages.modal.title.button.hint': '在新标签页中打开',
  'project-pages.errors.unknown-error.description.non-final': '如果刷新无法修复问题，则请{contactSupport}。',
  'project-pages.errors.unknown-error.title.non-final': '当前无法显示项目页面',
  'project-pages.generic-error.button.reload': '重新加载页面',
  'project-pages.generic-error.description': '出错了。请稍后重试。',
  'project-pages.generic-error.description.non-final': '出错了。请稍后重试。',
  'project-pages.generic-error.heading': '抱歉...',
  'project-pages.generic-error.title.non-final': '抱歉...',
  'project-pages.generic-info-flag.description': '发生错误。请重试；如果问题仍然存在，请联系支持团队',
  'project-pages.generic-success-flag.description.live-doc': '已成功连接 {connectedSpaceOrPageName} 实时文档。',
  'project-pages.generic-success-flag.description.page': '已成功连接 {connectedSpaceOrPageName} 页面。',
  'project-pages.generic-success-flag.description.space': '已成功连接 {connectedSpaceOrPageName} 空间。',
  'project-pages.generic-success-flag.heading.live-doc': '实时文档已连接',
  'project-pages.generic-success-flag.heading.page': '页面已连接',
  'project-pages.generic-success-flag.heading.space': '空间已连接',
  'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': '或者创建新空间',
  'project-pages.granular-pages.connect-space.button': '连接到 Confluence',
  'project-pages.granular-pages.connect-space.heading': '将此项目连接至 Confluence 空间或项目',
  'project-pages.improvement.contact-support': '联系支持团队',
  'project-pages.improvement.errors.access-error.description': '请尝试联系站点管理员以请求访问权限。',
  'project-pages.improvement.errors.access-error.title': '您无权查看项目页面',
  'project-pages.improvement.errors.page-tree-unknown-error.description':
    '尝试从已连接的 Confluence 空间显示页面时出错。如果刷新无法修复问题，则请{contactSupport}。',
  'project-pages.improvement.errors.page-tree-unknown-error.title': '显示项目页面时出现问题',
  'project-pages.improvement.errors.space-or-page-not-found.description':
    '已关联的 Confluence 空间或页面已移动、归档或删除。如果重新关联无法解决问题，请<link>联系支持团队</link>',
  'project-pages.improvement.errors.space-or-page-not-found.title': '未找到空间或页面',
  'project-pages.improvement.errors.unknown-error.description': '如果刷新无法修复问题，则请{contactSupport}。',
  'project-pages.improvement.errors.unknown-error.title': '当前无法显示项目页面',
  'project-pages.improvement.feature1': '无需离开 Jira 即可访问和创建文档',
  'project-pages.improvement.feature2': '提供用于会议、冲刺计划等的模板',
  'project-pages.improvement.feature3': '将文档同步到 Jira 以进行自动更新',
  'project-pages.improvement.heading-info': '掌握团队的知识，并改进工作的完成方式。',
  'project-pages.improvement.heading-info-v2': '为团队的所有项目文档创建一个统一的存放处',
  'project-pages.improvement.learn-more-button': '了解更多',
  'project-pages.improvement.powered-by': '技术支持',
  'project-pages.improvement.powered-by.tooltip': '在新标签页中打开 Confluence',
  'project-pages.improvement.preview-teaser': '解锁模板、项目页面等。',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description':
    '<p>通过自动更新状态标签使项目报告保持最新。</p><p>只需在文档中链接 Jira 工作单，文档即可自动显示与工作单同步更新的状态标签，这样您便无需再花时间创建手动报告。</p>',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': '无缝更新利益相关者',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description':
    '<p>使用我们的内置模板创建一致的文档。这些模板不仅易于使用，而且可根据您的需求进行自定义。</p><p>您不必离开正在处理的工作，即可直接在项目页面上使用模板。点击<a>此处</a>可浏览所有模板。</p>',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': '统一文档标准',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description':
    '<p>通过 Jira 的“项目页面”选项卡创建和管理文档，从而为重要信息创建单一数据源。</p><p>您知道项目页面可在 Confluence 上运行吗？Confluence 最多可供 10 位用户免费使用。请在“管理员设置”中邀请团队的其他成员。</p>',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title':
    '直接在 Jira 中查看您的项目页面',
  'project-pages.improvement.templates-sidebar.better-together-templates-header': '与您的 Jira 数据集成的模板',
  'project-pages.improvement.templates.better-together-preview-teaser': '已与 Jira 数据集成',
  'project-pages.improvement.templates.blank-page.description': '从头开始创建一个页面。',
  'project-pages.improvement.templates.blank-page.name': '空白页面',
  'project-pages.improvement.templates.decision.description': '记录重要的项目决策，并向您的团队传达。',
  'project-pages.improvement.templates.decision.name': '决策',
  'project-pages.improvement.templates.meeting-notes.description': '设置会议议程、做记录并与团队分享行动事项。',
  'project-pages.improvement.templates.meeting-notes.name': '会议记录',
  'project-pages.improvement.templates.post-expand.more': '更多模板',
  'project-pages.improvement.templates.post-expand.more.tooltip': '查看 Confluence 中的所有模板',
  'project-pages.improvement.templates.post-expand.subtitle': '热门模板',
  'project-pages.improvement.templates.post-expand.title': '创建页面',
  'project-pages.improvement.templates.pre-expand.more': '探索更多模板',
  'project-pages.improvement.templates.pre-expand.subtitle': '备受与您类似团队的青睐',
  'project-pages.improvement.templates.pre-expand.title': '预览模板',
  'project-pages.improvement.templates.product-requirements.description':
    '为您的产品或功能定义、追踪需求，以及确定需求范围。',
  'project-pages.improvement.templates.product-requirements.name': '产品需求',
  'project-pages.improvement.templates.retrospective.description':
    '哪些进展顺利？哪些可以改进？与您的团队一起为改进进行众包。',
  'project-pages.improvement.templates.retrospective.name': '回顾',
  'project-pages.improvement.templates.template.disabled-tooltip': '请先连接一个 Confluence 空间',
  'project-pages.improvement.templates.tutorial.content.confluence-templates':
    '<b>节约时间，减少手动任务</b>。Confluence 有许多页面<a>模板</a>可供使用，让您永远不必从零开始。集中精力构思技术文档、故障排除指南、项目计划、产品需求和更多内容。',
  'project-pages.improvement.templates.tutorial.content.edit-and-format':
    '<b>轻松编辑并设置格式。</b>使用顶部的编辑菜单调整标准文本格式，输入 <b>/</b> 便可轻松插入大量易于使用的集成。输入“<c>/表格</c>”以插入表格，或是输入“<c>/图片</c>”以插入图片。您也可以插入 Dropbox 链接 (<c>/dropbox</c>)、Microsoft Office 工具 (<c>/microsoft</c>) 或 Trello 面板和卡片 (<c>/trello</c>)。',
  'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': '输入 /，后接“表格”或“图片”',
  'project-pages.improvement.templates.tutorial.content.getting-started-tips': '以下是一些入门技巧：',
  'project-pages.improvement.templates.tutorial.content.handy-links': '易于使用的链接',
  'project-pages.improvement.templates.tutorial.content.jira-and-confluence': '搭配使用 Jira 和 Confluence',
  'project-pages.improvement.templates.tutorial.content.jira-charts':
    '使用真实的 Jira 数据在您的页面上创建图表。输入 <c>/Jira 图表</c>。',
  'project-pages.improvement.templates.tutorial.content.jira-links':
    '在您页面上的任意位置关联 Jira 事务。在您更新 Jira 事务时，页面上的链接也会实时更新。输入 <c>/Jira</c>。',
  'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh':
    '在您页面上的任意位置关联 Jira 工作项。在您更新工作项时，页面上的链接也会实时更新。输入 <c>/Jira</c>。',
  'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh':
    '在您页面上的任意位置关联 Jira 工作项。在您更新工作项时，页面上的链接也会实时更新。输入 &quot;<c>/Jira</c>&quot;。',
  'project-pages.improvement.templates.tutorial.content.jira-roadmaps':
    '使用 Jira 项目为您的页面嵌入交互式路线图和时间线。输入 <c>/jira 路线图</c>。',
  'project-pages.improvement.templates.tutorial.content.jira-timeline':
    '使用 Jira 项目为您的页面嵌入时间线。输入 <c>/jira 时间线</c>。',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic':
    '76% 的 Jira Software 客户表示，添加 Confluence 后，他们可以更快地交付项目。',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding':
    '76% 的 Jira 客户表示，添加 Confluence 后，他们可以更快地交付项目',
  'project-pages.improvement.templates.tutorial.content.spaces-and-pages':
    '<b>使用空间和页面</b>。空间是所有 Confluence 站点的组成部分，同时也是按类别整理页面的一种方式。您可将空间视为不同的文件夹或项目，而页面则是收纳在这些文件夹或项目中的文档。<a>了解有关空间使用方法的更多信息</a>',
  'project-pages.improvement.templates.tutorial.content.try-it-now': '立即试用',
  'project-pages.improvement.templates.tutorial.description': '了解如何编辑页面。',
  'project-pages.improvement.templates.tutorial.name': '欢迎访问“项目页面”！',
  'project-pages.improvement.terms-and-conditions-v2':
    '选择“立即试用”，即表示您确认您将注册 Confluence，并同意 Atlassian <termsLink>Cloud 服务条款</termsLink>和<privacyLink>隐私政策</privacyLink>。',
  'project-pages.improvement.title': '项目页面',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': '创建页面',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-description':
    '我们已添加 Confluence，以便您开始创建并链接所有项目文档。对最多 10 名用户免费。',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': '了解更多',
  'project-pages.improvement.transient-states.empty-state.create-page-button': '创建您的首个页面',
  'project-pages.improvement.transient-states.empty-state.description':
    '创建一些会议记录、产品需求、决定或其他内容来充实该空间。',
  'project-pages.improvement.transient-states.empty-state.title': '无限潜力，尽待挖掘',
  'project-pages.improvement.try-button': '在 Confluence 中试用此模板',
  'project-pages.improvement.try-it-now': '立即试用',
  'project-pages.improvement.try-lozenge': '试用',
  'project-pages.improvement.try-on-demand-button': '免费试用',
  'project-pages.page-deleted-flag.title': '页面已删除。',
  'project-pages.page-published-flag.title': '您的页面已发布。',
  'project-pages.unknown-error.description': '如果刷新无法修复问题，则请{contactSupport}。',
  'project-pages.unknown-error.heading': '当前无法显示项目页面',
};
